module.exports = __webpack_public_path__ + "static/media/parfume.ff03c815.png";